module.exports = __webpack_public_path__ + "03_long_grey.c54f5868.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/03_long_grey.png
// module id = xYAk
// module chunks = 0